import { isNil } from "@fxts/core"

import { formatBusinessRegistrationNumber } from "@/utils/format"

/**
 * 사업자등록번호가 같은지 비교합니다.
 * 사업자등록번호가 formatting하여 formatting 되지 않은 값도 비교합니다.
 */
export const isEqualsBusinessRegistrationNumber = (a: string, b: string) => {
  if (isNil(a) && isNil(b)) {
    return false
  }

  if (a === "" && b === "") {
    return false
  }

  const aValue = formatBusinessRegistrationNumber(a)
  const bValue = formatBusinessRegistrationNumber(b)
  return aValue === bValue
}
